var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import PlayIcon from "../../common/images/play_icon.svg";
import css from './style.pcss';
import { helper } from "../../common/helper";
var RTLLivestream = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLLivestream, _LitElement);
  function RTLLivestream() {
    var _this;
    _classCallCheck(this, RTLLivestream);
    _this = _callSuper(this, RTLLivestream);
    _this.online = false;
    _this.hasSportBuffOverlay = false;
    _this.slug = "";
    _this.copyright = '';
    _this.isUserGeoblocked = false;
    _this.location = window.location.origin;
    if (process.env.NODE_ENV === 'development') {
      _this.location = 'http://localhost:8080';
    }
    return _this;
  }
  _createClass(RTLLivestream, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(RTLLivestream.prototype), "connectedCallback", this).call(this);
            case 2:
              _context.next = 4;
              return this.fetchData();
            case 4:
              _context.next = 6;
              return this.fetchGeoblockData();
            case 6:
              this.interval = setInterval(this.fetchData.bind(this), 30000);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "fetchGeoblockData",
    value: function () {
      var _fetchGeoblockData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var geoblockResp;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch("https://stream.rtl.lu/data/live/tele/test/geoblock");
            case 2:
              geoblockResp = _context2.sent;
              this.isUserGeoblocked = geoblockResp.status !== 200;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchGeoblockData() {
        return _fetchGeoblockData.apply(this, arguments);
      }
      return fetchGeoblockData;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var weeklySuffix, resp;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.id) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              weeklySuffix = '';
              if (this.weekly) weeklySuffix = 'weekly/';
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(this.location + '/api/livestreams/' + weeklySuffix + this.id).then(function (resp) {
                return resp.json();
              });
            case 7:
              resp = _context3.sent;
              if (resp.online != this.online) {
                if (resp.online) {
                  this.data = resp;
                } else {
                  this.data = null;
                }
                this.online = resp.online;
              }
              console.log("RESP LSgeoblock", resp.geoblock);
              this.hasSportBuffOverlay = resp.overlay === "sportbuff";
              this.slug = resp.slug;
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              if (this.interval) clearInterval(this.interval);
              console.log('ERROR: ' + _context3.t0.message);
            case 18:
              ;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 14]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "_renderChannel",
    value: function _renderChannel(data) {
      var hls = data.source_data.ideviceuri;
      var dash = data.source_data.dash;
      var poster = data.source_data.screenshot;
      var name = data.name;
      var description = data.description;
      var banner = data.banner_img;
      var bannerHref = data.banner_href;
      var streamType = data.type;
      var sourceType = data.source_type;
      var scheduleId = data.id;
      var streamDisplayTimeIn = data.display_timein;
      var streamDisplayTimeOut = data.display_timeout;
      var contentId = data.content_id;
      if (this.weekly) {
        contentId = data.source_data.content_id;
      }
      var channelname = data.source_data.title;
      var channelencoder = data.source_data.channel_id;
      var show = data.emission;
      // ${name ? html`<div class="media-video__title">${name}</div>` : ``}

      if (poster === "https://stream.rtl.lu/data/live/thumbnails/stream1.jpg") poster = "https://static.rtl.lu/livestream/channel1.jpg";
      if (data.login_required) {
        console.log("STREAMDATA", data.source_data);
        var playUrl = `https://play.rtl.lu/live/${data.source_data.channel_id}`;
        var appUrl = `rtlluplay://live/livestream:${data.source_data.channel_id}`;
        var posterImg = this.data.poster_image;
        if (!posterImg && this.data.channel_screenshot) posterImg = this.data.channel_screenshot;
        return html(_t || (_t = _`<a target="_blank" @click=${0}><div class="media-image">
                            <div class="media-image__container login_container">
                                <img class="media-image__image responsive-img background" src="${0}" alt="preview"/>
                                <img class="media-image__image responsive-img overlay" src="${0}" alt="preview"/>
                            </div>
                        </div></a>`), function () {
          return helper.openPlayLink(playUrl, appUrl);
        }, posterImg, PlayIcon);
      }
      return html(_t2 || (_t2 = _`
            <div class="media-video">
                <rtl-player
                        sportbuffid=${0}
                        show="${0}"
                        ?usedrm=${0}
                        contentid="${0}"
                        poster="${0}"
                        hls="${0}"
                        dash="${0}"
                        title="${0}"
                        type="live"
                        ?sendNoAnalytics=${0}
                        class="media-video__player"
                        channelname="${0}"
                        channelencoder="${0}"
                        streamtype="${0}"
                        sourcetype="${0}"
                        scheduleid="${0}"
                        streamdisplaytimein="${0}"
                        streamdisplaytimeout="${0}"
                ></rtl-player>
                ${0}
                ${0}
            </div>
        `), this.hasSportBuffOverlay ? this.slug : "", show, data.drm, contentId, poster, hls, dash, name, this.isUserGeoblocked && data.geoblock, channelname, channelencoder, streamType, sourceType, scheduleId, streamDisplayTimeIn, streamDisplayTimeOut, description ? html(_t3 || (_t3 = _`<div class="media-video__summary">${0}</div>`), description) : '', bannerHref ? html(_t4 || (_t4 = _`
                    <a href="${0}">
                    ${0}
                    </a>
                `), bannerHref, banner ? html(_t5 || (_t5 = _`<img src="${0}" alt="${0}" width="100%" />`), banner, name) : '') : html(_t6 || (_t6 = _`${0}`), banner ? html(_t7 || (_t7 = _`<img src="${0}" alt="${0}" width="100%" />`), banner, name) : ''));
    }
  }, {
    key: "_renderEmbed",
    value: function _renderEmbed(data) {
      return html(_t8 || (_t8 = _`<div class="media-embed"><div class="media-embed__video">${0}</div></div>`), unsafeHTML(data.source_data));
    }
  }, {
    key: "_renderSource",
    value: function _renderSource(data) {
      return html(_t9 || (_t9 = _`<div>${0}</div>`), data.source_data);
    }
  }, {
    key: "render",
    value: function render() {
      var response = html(_t10 || (_t10 = _``));
      var copyrightElem = null;
      if (this.copyright) {
        copyrightElem = html(_t11 || (_t11 = _`<p class="media-image__summary">© ${0}</p>`), this.copyright);
      }
      if (this.image) {
        response = html(_t12 || (_t12 = _`<div class="media-image">
                                <div class="media-image__container">
                                    <img class="media-image__image  responsive-img" src="${0}" alt="preview"/>
                                </div>
                                ${0}
                            </div>`), this.image, copyrightElem);
      }
      var data = this.data;
      if (this.weekly && this.data) {
        data = this.data.online;
      }
      console.log("DATA", data);
      if (data) {
        if (data.source_type === 'channel') {
          response = this._renderChannel(data);
        }
        if (data.source_type === 'embed') {
          response = this._renderEmbed(data);
        }
        if (data.source_type === 'source') {
          response = this._renderSource(data);
        }
      }
      return html(_t13 || (_t13 = _`<style>${0}</style> ${0}`), css, response);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: Number
        },
        id: {
          type: Number
        },
        online: {
          type: Boolean
        },
        weekly: {
          type: Boolean
        },
        image: {
          type: String
        },
        copyright: {
          type: String
        },
        isUserGeoblocked: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLLivestream;
}(LitElement);
export { RTLLivestream as default };
window.customElements.define('rtl-livestream', RTLLivestream);